module.exports = __webpack_public_path__ + "static/media/2.98cf4abf.jpg";